<template>
  <div class="b2b-sidePane">
    <el-tabs
      v-model="activeValue"
      @tab-click="tabClick"
      tab-position="left"
      type="card"
    >
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.label"
        :name="item.name"
      >
        <slot :name="item.name"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  props: {
    active: {
      type: String,
      default: "first"
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeValue: this.active
    };
  },
  methods: {
    tabClick() {
      this.$emit("updateActive", this.activeValue);
    }
  }
};
</script>

<style lang="scss">
.b2b-sidePane {
  .el-tabs__header {
    width: 30%;
  }
  .el-tabs__nav {
    border: none !important;
  }
  .el-tabs__item {
    text-align: center;
    margin-bottom: 1px;
    padding: 10px 30px;
    height: auto;
    color: #fff;
    background: rgb(36, 38, 85);
    font-size: 14px;
    white-space: normal;
  }
  .el-tabs__item:hover{
    background: #01aaa3;
  }
  .el-tabs__item.is-active {
    color: #000;
    background: rgb(245, 245, 245) !important;
  }
}
</style>
